module.exports = __webpack_public_path__ + "static/media/answer.d784e0cb.svg";